import React from "react";

const RevertemosProblemas = () => {
    return (
        <div className="relative w-full bg-[#040116] overflow-hidden py-30">
            {/* Background image - positioned to show only half */}
            <div className="absolute left-0 right-0 w-full overflow-visible ">
                <img
                    src="/assets/cover-solucoes-perso.png"
                    alt="Background"
                    className="w-full min-w-full absolute -bottom-190"
                />
            </div>

            {/* Blur effect */}
            <div
                className="absolute inset-0 blur-3xl w-[80%] mx-auto left-0 right-0 mt-16 rounded-full opacity-80"
                style={{ backgroundColor: "#000" }}
            />
            
            {/* Content */}
            <div className="relative z-10 container mx-auto px-4 text-center">
                <h2 className="font-inter-regular text-white text-4xl md:text-5xl mb-2 max-w-4xl mx-auto">
                    Revertemos problemas em resultados,{" "}
                    <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] text-transparent bg-clip-text">
                        demandas complexas em soluções ágeis.
                    </span>
                </h2>
            </div>
        </div>
    );
};

export default RevertemosProblemas;
